import React from 'react';
import {UserProfileOverviewContent} from "./tabs/overview/UserProfileOverviewContent";
import {UserProfileHealthContent} from "./tabs/health/UserProfileHealthContent";
import {SettingsLayout} from "@backstage/plugin-user-settings";

export const userProfilePage = (
  <SettingsLayout title={"User Profile"}>
    <SettingsLayout.Route path="/" title="Overview">
      <UserProfileOverviewContent />
    </SettingsLayout.Route>
    <SettingsLayout.Route path="/health" title="Health">
      <UserProfileHealthContent />
    </SettingsLayout.Route>
  </SettingsLayout>
);
